import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '../util/withRouter';
import { windowLocation } from '../util/url';
import { connect } from 'react-redux';
import _ from 'lodash';

export default function (ComposedComponent) {
  class RequireStreamAccess extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      windowLocation() && windowLocation().replace(to + windowLocation().search);
    }

    render() {
      const { user, routeParams, route, streams } = this.props;

      if (this.props.isLoading) {
        return <div></div>;
      }

      if (!user.permissions) {
        this.redirect('/');
        return null;
      }

      const fullAccess = user.permissions.manageStreams;
      const viewAccess = user.permissions.manageStreamsViewOnly;

      if (routeParams.id) {
        const granularAccess = user.permissions && user.permissions.streams &&  _.find(user.permissions.streams, s => s.streamId === routeParams.id);
        
        const access =
          fullAccess && { view: true, edit: true, delete: true } ||
          viewAccess && { view: true } ||
          granularAccess || {};

        if (route.path.indexOf('report') > -1 && !access.view && !access.edit && !access.delete) {
          this.redirect('/report');
          return null;
        } else if (route.path.indexOf('configure') > -1 && !access.edit) {
          this.redirect('/report');
          return null;
        }
      } else {
        if (route.path.indexOf('report') > -1 && !(user.permissions.streams && user.permissions.streams.length) && !(fullAccess || viewAccess)) {
          this.redirect('/no-streams');
          return null;
        }
        if (route.path.indexOf('configure') > -1 && !user.permissions.createStreams) {
          this.redirect('/report');
          return null;
        }
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      user: state.auth.user,
      streams: state.report.streams,
      isLoading: state.auth.isLoading,
    };
  }

  return withRouter(connect(mapStateToProps)(RequireStreamAccess));
}
